export default function Logo({ className = "", size = 22 }) {
  const sqW = Math.round(size * 0.27);
  const sqH = Math.round(size * 0.45);
  const gap = Math.round(size * 0.14);

  return (
    <div
      className={`flex items-baseline ${className}`}
      data-testid="svgl-logo"
      aria-label="SVGL"
    >
      <span
        className="font-display font-black text-white uppercase leading-none"
        style={{
          fontFamily: '"Azeret Mono", "IBM Plex Mono", monospace',
          fontStretch: "condensed",
          letterSpacing: "-0.06em",
          fontSize: `${size}px`,
          transform: "scaleY(1.15)",
          transformOrigin: "bottom",
        }}
      >
        SVGL
      </span>
      <span
        aria-hidden="true"
        className="inline-block align-baseline"
        style={{
          width: `${sqW}px`,
          height: `${sqH}px`,
          marginLeft: `${gap}px`,
          background: "#CCFF00",
          boxShadow: "0 0 10px rgba(204,255,0,0.55)",
          flexShrink: 0,
        }}
      />
    </div>
  );
}
